<template>
  <v-container class="login" fill-height>
    <v-row align-content="center" align="center" justify="center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/logo-uys.png')"
          class="my-3"
          contain  
          height="70" 
        />
      </v-col>
      <v-col cols="12">
          <v-text-field
            v-model="user.email"
            :label="email_label"
            required
          ></v-text-field>
      </v-col>
      <v-col cols="12">
          <v-text-field 
            v-model="user.password"
            :type="'password'"
            :label="password_label"
            counter
          ></v-text-field>
      </v-col>
      <v-col cols="12" class="resetPassword">
        <a @click="resetConfirm = true">Mot de passe oublié</a>
      </v-col>
      <v-col cols="12" v-if="error">
        <div class="error-login">{{ $t('messages.login.error') }}</div>
      </v-col>
      <v-col cols="auto">
        <v-btn depressed small color="primary" @click="loginUser">{{ $t('messages.login.connect') }}</v-btn>
      </v-col>
    </v-row>
    <v-dialog
        v-model="resetConfirm"
        persistent
        max-width="320"
        >
            <v-card>
                <v-card-title style="word-break: unset;">
                Réinitialiser votre mot de passe
                </v-card-title>
                <v-card-text v-if="!resetSent">
                  Renseignez votre e-mail, un nouveau mot de passe vous sera envoyé.
                  <v-text-field
                        v-model="email"
                        hide-details
                        :label="email_label"
                        type="email"
                    ></v-text-field>
                    <p v-if="errorText != ''" class="errorText">{{ errorText }}</p>
                </v-card-text>
                <v-card-text v-if="resetSent">
                  Votre nouveau mot de passe vous a été envoyé par email.
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="grey darken-1"
                    text
                    @click="resetDialog"
                >
                    Annuler
                </v-btn>
                <v-btn
                   v-if="!resetSent"
                    color="primary"
                    text
                    @click="resetPassword">
                    Réinitialiser
                </v-btn>
                 <v-btn
                   v-if="resetSent"
                    color="primary"
                    text
                    @click="resetDialog">
                    OK
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </v-container>
</template>
<script>
export default {
  name: 'Login',
  data() {
    return {
      user: {
        email:"",
        password: "",
      },
      email:"",
      error:false,
      resetConfirm:false,
      resetSent: false,
      errorText:"",
    }
  },
  created() {
      if(this.$store.state.loader){
          this.$store.dispatch('setLoader', false)
      }
  },
  beforeDestroy() {
    let email = this.$store.state.user.email;
    let userIdApp = this.$store.state.user.id;
    OneSignal.push(function() {
      OneSignal.isPushNotificationsEnabled(function(isEnabled) {
        if (isEnabled)
          console.log("Push notifications are enabled!");
        else
          console.log("Push notifications are not enabled yet.");    
          OneSignal.showNativePrompt();
      });
    });
  },
  methods: {
    resetDialog() {
      this.resetConfirm = false;
      this.resetSent = false;
      this.errorText = "";
      this.email = "";
    },
    resetPassword() {
      if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email))
      {
        this.errorText = "";
        this.$store.dispatch('setLoader', true).then((e) => {
          this.$store.dispatch('resetPassword', { email: this.email }).then((e) => {
            this.resetSent = true;
            this.$store.dispatch('setLoader', false)
          })
        })
        
        
      } else {
        this.errorText = "Merci de renseigner une adresse mail valide"
      }
    },
    loginUser() {
      this.user.email = this.user.email.replace(/\s+/g, "");
      this.$store.dispatch('setLoader', true)
      this.$store.dispatch('getAuth', this.user).then(() => {
        if(this.$store.state.user.id){
          this.$store.dispatch('getProjets', {}).then(() => {
            if(!this.$store.state.auth){
                this.error = true;
                this.$store.dispatch('setLoader', false)
            } else {
              
              if(this.$store.state.projets.length > 1){
                  this.$router.push({name: "Operations"})
              } else {
                this.$store.dispatch('getLeadProjets', {codeProjet: this.$store.state.projets[0].code_projet}).then(() => {
                  this.$store.dispatch('getNotifs', {id_utilisateur: this.$store.state.user.id, code_projet : this.$store.state.projets[0].code_projet}).then((e) => {
                    this.$store.dispatch('getMedias', {id_utilisateur: this.$store.state.user.id, code_projet : this.$store.state.projets[0].code_projet}).then((e) => {
                      this.$store.dispatch('getStatistiques', {codeProjet : this.$store.state.projets[0].code_projet}).then(() => {
                        if(this.$route.query.redirectFrom){
                            if(this.$route.query.redirectName == 'Details'){
                              const lead = this.$store.state.leads.find((e) => e.id == this.$route.query.id);
                              this.$store.dispatch('getDetailLead', lead.code_lead).then(() => {
                                  this.$router.push({ path: this.$route.query.redirectFrom})
                              })
                            } else if(this.$route.query.redirectName == 'Home'){
                              this.$router.push({name: "Operations"})
                            } else {
                              this.$router.push({ path: this.$route.query.redirectFrom})
                            }
                        } else {
                            this.$router.push({ name: 'Todo', params: { code: this.$store.state.projets[0].code_projet } })
                        }
                      })
                    })
                  })
                  
                }) 
              }
            }
          })
        } else {
            this.error = true;
            this.$store.dispatch('setLoader', false)
        }
      })
    }
  },
  computed: {
    email_label: function(){
      return this.$t('messages.login.email')
    },
    password_label: function(){
      return this.$t('messages.login.password')
    },
    isLoggedIn: function(){
      return this.$store.state.auth;
    }
  },
  watch: {

  },
}
</script>
<style lang="scss">
  .login {
    padding: 20px;
    .error-login {
      color:red;
    }
    .resetPassword {
      font-size:0.8em;
      text-decoration: underline;
      text-align:right;
    }
  }
  .errorText {
    color:red;
    font-size:0.9em;
  }
</style>